@if (displayModel$ | async; as model) {
  <app-toolbar [actions]="toolbarActions"></app-toolbar>
  <app-model-canvas [model]="model"></app-model-canvas>
}
